import { IAgent, IAgentGetResponse, Route } from "@edgetier/watchtower-types";
import { AxiosError } from "axios";
import { useQuery, UseQueryOptions } from "react-query";
import { axios } from "utilities/axios";

/**
 * Request an agent's details from the backend.
 * @param agentId The ID of the agent.
 */
export const requestAgent = async (agentId: string) => {
    const { data } = await axios.get<IAgentGetResponse>(Route.Agent.replace(":agentId", agentId));
    return data;
};

/**
 * A query to request an agent's details from the backend.
 * @param agentId The ID of the agent.
 */
export const useAgent = <T = IAgent>(agentId: string, configuration: UseQueryOptions<IAgent, AxiosError, T> = {}) => {
    return useQuery<IAgent, AxiosError, T>([Route.Agent, agentId], () => requestAgent(agentId), configuration);
};
